import React from 'react'
import ReactDOM from 'react-dom'
import PropTypes from 'prop-types'
import { Flags } from 'react-feature-flags'
import { useLocation } from 'react-router-dom'

import { connect } from 'react-redux'
import Share from './Share'
import CALogo from '../../img/ca-logo.svg'
import OPRLogo from '../../img/logo-opr.png'
import LCILogo from '../../img/lci-logo.png'

import HCDLogo from '../../img/logo-hcd.png'
import HomeIcon from '../../img/icon-home.svg'
import TwitterLogo from '../../img/twitter-logo.svg'
import YouTubeLogo from '../../img/youtube-logo.svg'
import SVGWrapper from './SVGWrapper'
import Account from './Account'
import { setDialog as setDialogConnect } from '../actions/navigation'

export class Header extends React.Component {
    constructor(props) {
        super(props)

        this.state = { x: null, share: false }
        this.shareLinkRef = React.createRef()

        this.onClick = this.onClick.bind(this)
    }

    onClick(e) {
        if (!Array.from(document.getElementsByClassName('share-content')).some(node => node.contains(e.target))) {
            window.document.removeEventListener('click', this.onClick)
            this.setState({ share: false })
        }
    }

    render() {
        const { x, share } = this.state
        const { path, setDialog, isLoggedIn } = this.props

        const isPasswordRoute = path === '/users/set-password/'
        const isFormRoute = path === '/submission-form/'

        return (
            <>
                <header className={`header is-hidden-mobile ${isFormRoute ? 'shell' : ''}`}>
                    <div className="columns">
                        <div className="column is-narrow">
                            <ul className="icons-list">
                                <li>
                                    <a href="http://www.ca.gov/" target="_blank">
                                        <span className="svg-icon">
                                            <SVGWrapper title="CA.GOV Logo">
                                                <CALogo width={44} height={32} />
                                            </SVGWrapper>
                                        </span>
                                    </a>
                                </li>
                                <li>
                                    <a href="https://lci.ca.gov/" target="_blank">
                                        <span className="png-icon">
                                            <img
                                                alt="Governor's Office of Land Use and Climate Innovation "
                                                src={LCILogo}
                                                style={{ height: '32px' }}
                                            />
                                        </span>
                                    </a>
                                </li>
                                <li>
                                    <a href="https://www.hcd.ca.gov/" target="_blank">
                                        <span className="png-icon">
                                            <img
                                                alt="California Housing and Community Development Logo"
                                                src={HCDLogo}
                                                style={{ height: '32px' }}
                                            />
                                        </span>
                                    </a>
                                </li>
                                <li>
                                    <a href="http://opr.ca.gov/" target="_blank">
                                        <span className="svg-icon opr-icon">
                                            <SVGWrapper title="OPR Home Icon">
                                                <HomeIcon width={18} height={18} />
                                            </SVGWrapper>
                                        </span>
                                    </a>
                                </li>
                                <li>
                                    <a href="https://twitter.com/Cal_OPR" target="_blank">
                                        <span className="svg-icon opr-icon">
                                            <SVGWrapper title="Twitter Logo">
                                                <TwitterLogo height={28} />
                                            </SVGWrapper>
                                        </span>
                                    </a>
                                </li>
                                <li>
                                    <a href="https://www.youtube.com/channel/UCTBmAaS7WDxOcyjo85dcXtA" target="_blank">
                                        <span className="svg-icon opr-icon">
                                            <SVGWrapper title="YouTube Logo">
                                                <YouTubeLogo height={16} width={22} />
                                            </SVGWrapper>
                                        </span>
                                    </a>
                                </li>
                            </ul>
                        </div>
                        <div className={`column  ${!isFormRoute ? 'has-text-centered' : 'has-text-right'}`}>
                            <h3 className="title is-static-3" style={{ minWidth: 'max-content' }}>
                                <a href="/">
                                    Site Check <span className="check">&#10003;</span>
                                </a>
                            </h3>
                        </div>
                        {!isFormRoute && (
                            <div className="column is-narrow">
                                <ul className="icons-list">
                                    <li>
                                        <button onClick={() => setDialog('about')}>About</button>
                                    </li>
                                    {!isPasswordRoute &&
                                        (isLoggedIn ? (
                                            <li>
                                                <button
                                                    onClick={() => setDialog('projectSave')}
                                                    className="button is-small is-accent is-nav"
                                                    style={{ position: 'relative', bottom: '2px' }}
                                                >
                                                    Save Project
                                                </button>
                                            </li>
                                        ) : (
                                            <li>
                                                <button
                                                    ref={this.shareLinkRef}
                                                    onClick={() => {
                                                        const bounds = this.shareLinkRef.current.getBoundingClientRect()
                                                        this.setState({ x: bounds.left })

                                                        window.document.addEventListener('click', this.onClick)

                                                        if (share) {
                                                            window.document.removeEventListener('click', this.onClick)
                                                            this.setState({ share: false })
                                                        } else {
                                                            window.document.addEventListener('click', this.onClick)
                                                            this.setState({ share: true })
                                                        }
                                                    }}
                                                >
                                                    Create Link
                                                </button>
                                                {share &&
                                                    ReactDOM.createPortal(
                                                        <Share x={x} />,
                                                        document.getElementById('SharePortal')
                                                    )}
                                            </li>
                                        ))}
                                    <li>
                                        <button onClick={() => setDialog('methods')}>Methods</button>
                                    </li>
                                    <li>
                                        <button onClick={() => setDialog('other')}>Other Resources</button>
                                    </li>
                                    {!isPasswordRoute && <Account />}
                                </ul>
                            </div>
                        )}
                    </div>
                </header>
            </>
        )
    }
}

Header.propTypes = {
    // react-router (wrapper)
    path: PropTypes.string.isRequired,
    // redux state
    isLoggedIn: PropTypes.bool.isRequired,
    // redux actions
    setDialog: PropTypes.func.isRequired
}

const ConnectedHeader = connect(
    ({ account: { email } }) => ({
        isLoggedIn: !!email
    }),
    dispatch => ({
        setDialog: modalName => dispatch(setDialogConnect(modalName))
    })
)(Header)

export default props => {
    const path = useLocation().pathname
    return <ConnectedHeader path={path} {...props} />
}
